export function SubDomin({
  field, // { name, value, onChange, onBlur }
  form: {touched, errors}, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  label,
  withFeedbackLabel = true,
  customFeedbackLabel,
  type = 'text',
  ...props
}: any) {
  return (
    <>
      <div className='input-group mb-3'>
        <div className='input-group-prepend'>
          <span className='input-group-text'>https://</span>
        </div>
        <input
          value={field.value}
          {...field}
          {...props}
          type='text'
          className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
          aria-label='Amount (to the nearest dollar)'
        />
        <div className='input-group-append'>
          <span className='input-group-text'>.messagecenter.com.au</span>
        </div>
      </div>
    </>
  )
}
